var map = {
	"./bg.json": [
		6126
	],
	"./de.json": [
		81358,
		358
	],
	"./en.json": [
		18407,
		407
	],
	"./fr.json": [
		8779,
		779
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 73529;
module.exports = webpackAsyncContext;